// extracted by mini-css-extract-plugin
module.exports = {"row":"GithubContribution_row__2wG2B","stats":"GithubContribution_stats__147hm","loading":"GithubContribution_loading__3Bi8Q","wrapper":"GithubContribution_wrapper__2yqgM"};